export default "__VITE_ASSET__pkQusBS0__"